var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrownSimpleIcon = function SvgCrownSimpleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#crown-simple-icon_svg__a)",
    d: "M44.756 13.781a2.98 2.98 0 0 0-3.131-.43l-9.487 4.218-5.513-9.938a3.02 3.02 0 0 0-5.25 0l-5.512 9.938-9.488-4.219a3 3 0 0 0-4.144 3.431l4.763 20.307A2.98 2.98 0 0 0 8.38 38.98c.47.282 1.008.43 1.556.432q.402-.001.788-.113a49.8 49.8 0 0 1 26.531 0 3.1 3.1 0 0 0 2.344-.319 2.92 2.92 0 0 0 1.387-1.893L45.77 16.78a3 3 0 0 0-1.013-3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown-simple-icon_svg__a",
    x1: 23.999,
    x2: 23.999,
    y1: 6.103,
    y2: 39.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5585FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012C99"
  })))));
};
export default SvgCrownSimpleIcon;